import { render, staticRenderFns } from "./gj-base-table.vue?vue&type=template&id=35f51248&scoped=true&"
import script from "./gj-base-table.vue?vue&type=script&lang=js&"
export * from "./gj-base-table.vue?vue&type=script&lang=js&"
import style0 from "./gj-base-table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gj-base-table.vue?vue&type=style&index=1&id=35f51248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f51248",
  null
  
)

export default component.exports